import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';

import * as schemas from 'store/common/schemas';
import * as entitySelectors from 'store/entities/selectors';
import * as helpers from './helpers';

export const selectCompanyAdvisorConnectionById = createSelector(
  entitySelectors.selectAllEntities,
  (state, props) => props.id,
  (entities, id) => {
    const result = denormalize(id, schemas.companyAdvisorConnection, entities);
    if (result) {
      result.type = helpers.calculateAdvisorConnectionType(result);
      result.status = helpers.calculateAdvisorConnectionStatus(result);
    }
    return result;
  }
);



// WEBPACK FOOTER //
// ./src/store/features/company-advisor-connections/selectors.js